<template>
    <Header></Header>
    <Navbar href="/" style="max-width: 1200px;margin: auto;">
        <template #back>vers Accueil</template>
        <template #title>Email Blacklist</template>
    </Navbar>

    <section id="blacklist" class="main">
        <Sub_EmailBlacklistForm></Sub_EmailBlacklistForm>
    </section>
</template>

<script setup>
import Header from '@/components/Header.vue';
import Navbar from '@/components/Navbar.vue';
import Sub_EmailBlacklistForm from './Sub_EmailBlacklistForm.vue';

</script>

<style lang="scss" scoped>
#blacklist.main {
    background-color: #fff;
    border-radius: 15px;

    width: 80vw;

    margin-inline: auto;
    margin-bottom: 2rem;
    padding: 1.5rem;
}
</style>